import { LoggedInUserDetailsActions, LoggedInUserDetails } from '../model/index';

export function loggedInUserDetails(loggedInUserDetails: object): LoggedInUserDetailsActions {
	return {
		type: LoggedInUserDetails.LOGGED_IN_USER_DETAILS,
		payload: loggedInUserDetails,
	};
}
